import './ArticleWrapper.css';

export default function ArticleWrapper ({ children = null, className="" }) {
    return (
        <article className={`article-wrapper ${className}`}>
            {children}
        </article>
    );
};